// ** Type import
import { HorizontalNavItemsType } from 'src/@core/layouts/types'

const navigation = (): HorizontalNavItemsType => [
    {
        title: 'Home',
        path: '/home',
        icon: 'mdi:home-outline'
    },
    {
        title: 'Notificaciones',
        path: '/notifications',
        icon: 'mdi:bell-outline'
    },
    {
        title: 'Informacion',
        path: '/limits',
        icon: 'mdi:chart-box-outline'
    },
    {
        title: 'Administración',
        path: '/admin',
        icon: 'mdi:account-group-outline',
        securityObject: 'MenuAccesoModuloAdministrador'
    }
]

export default navigation
